import { forwardRef, type Ref } from "react";

import { type SvgExtendedProps } from "./types";

function SvgGift(
  {
    strokeColor = "#0C1C43",
    gradientStartColor = "#D7D4FF",
    gradientEndColor = "#F6F3F1",
    ...props
  }: SvgExtendedProps,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" width={50} height={50} fill="none" {...props}>
      <rect width={46} height={46} x={2} y={2} stroke="url(#gift_svg__a)" strokeWidth={4} rx={23} />
      <path
        stroke={strokeColor}
        strokeLinejoin="round"
        d="M25 21.786v-1.429m0 1.429h-1.515c-1.674 0-3.03-1.28-3.03-2.857 0-.79.678-1.429 1.515-1.429 1.673 0 3.03 1.28 3.03 2.857m0 1.429h1.515c1.674 0 3.03-1.28 3.03-2.857 0-.79-.678-1.429-1.515-1.429-1.673 0-3.03 1.28-3.03 2.857m0 1.429h-5.682c-1.004 0-1.818.767-1.818 1.714v.214c0 .635.366 1.189.91 1.485M25 21.786h5.682c1.004 0 1.818.767 1.818 1.714v.214c0 .635-.366 1.189-.91 1.485M25 21.786v3.643m0 7.071h-4.773c-1.004 0-1.818-.767-1.818-1.714v-5.587M25 32.5h4.773c1.004 0 1.818-.767 1.818-1.714v-5.587M25 32.5v-7.071m0 0h5.682c.331 0 .642-.084.909-.23M25 25.43h-5.682c-.331 0-.642-.084-.909-.23m0-.199v.2m13.182 0V25"
      />
      <defs>
        <linearGradient
          id="gift_svg__a"
          x1={25}
          x2={25}
          y1={0}
          y2={50}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradientStartColor} />
          <stop offset={1} stopColor={gradientEndColor} />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgGift);
export default ForwardRef;
